(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["celluma-localization"] && !Shopify.designMode) return;
  try {
    const initializeCellumaLocalization = () => {
    document.querySelectorAll('.celluma-localization').forEach(form => {
      if (form.dataset.localizationReady === 'true') return;
      form.dataset.localizationReady = 'true';
      const country = form.querySelector('select[name="country_code"]');
      const language = form.querySelector('button[name="language_code"][aria-current="true"]');
      const summary = form.closest('.region-picker')?.querySelector('summary');
      const label = form.querySelector('label');
      if (summary && label && country) {
        summary.setAttribute('aria-label', `${label.textContent.trim()}: ${country.selectedOptions[0].textContent.trim()}`);
      }
      country?.addEventListener('change', () => {
        if (language) form.requestSubmit(language);
        else form.requestSubmit();
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCellumaLocalization, { once: true });
  } else {
    initializeCellumaLocalization();
  }
  document.addEventListener('shopify:section:load', initializeCellumaLocalization);
  } catch(e) { console.error(e); }
})();

})();
